import { getDiscountDetails } from '@libs/api-proxy-client';

export const fetchPromoDetails = ({ promoKey }: { promoKey: string }) => getDiscountDetails(promoKey);
